import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { FiHeart, FiShoppingCart, FiStar } from 'react-icons/fi';
import { useApp } from '../../context/AppContext';
import './ProductCard.css';

export default function ProductCard({ product }) {
  const navigate = useNavigate();
  const { addToCart, addToWishlist } = useApp();
  const [hovered, setHovered] = useState(false);
  const [wishlisted, setWishlisted] = useState(false);

  if (!product) return null;

  const outOfStock = product.inventory !== undefined && product.inventory !== null && Number(product.inventory) <= 0;

  const img = product.image1
    ? (product.image1.startsWith('http') ? product.image1 : `/uploads/${product.image1}`)
    : 'https://placehold.co/300x300/F5F0E8/800020?text=Abhiras';

  const truncate = (str, n) => str && str.length > n ? str.slice(0, n) + '…' : str;

  const handleWishlist = async (e) => {
    e.stopPropagation();
    const ok = await addToWishlist(product.product_id);
    if (ok) setWishlisted(true);
  };

  const handleCart = async (e) => {
    e.stopPropagation();
    if (outOfStock) return;
    addToCart(product.product_id);
  };

  const discountPct = product.origprice && product.selling_price
    ? Math.round(((product.origprice - product.selling_price) / product.origprice) * 100)
    : product.discount || 0;

  return (
    <div
      className={`product-card${outOfStock ? ' out-of-stock' : ''}`}
      onClick={() => navigate(`/product/${product.product_id}`)}
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
    >
      <div className="card-img-wrap">
        <img src={img} alt={product.product_name} loading="lazy" />
        {outOfStock && <span className="oos-badge">Out of Stock</span>}
        {!outOfStock && discountPct > 0 && <span className="discount-badge">{discountPct}% OFF</span>}
        <div className={`card-overlay${hovered ? ' show' : ''}`}>
          <p className="overlay-desc">{truncate(product.description, 100)}</p>
          <div className="overlay-actions">
            <button onClick={handleWishlist} className={`ov-btn${wishlisted ? ' active' : ''}`} title="Wishlist">
              <FiHeart size={16} />
            </button>
            {!outOfStock && (
              <button onClick={handleCart} className="ov-btn cart" title="Add to Cart">
                <FiShoppingCart size={16} />
              </button>
            )}
          </div>
        </div>
      </div>
      <div className="card-info">
        <p className="card-category">{product.category || 'Jewellery'}</p>
        <h3 className="card-title">{truncate(product.product_name, 45)}</h3>
        <div className="card-price-row">
          <span className="card-price">₹{Number(product.selling_price).toLocaleString('en-IN')}</span>
          {product.origprice && product.origprice > product.selling_price && (
            <span className="card-orig">₹{Number(product.origprice).toLocaleString('en-IN')}</span>
          )}
        </div>
        {product.avg_rating > 0 && (
          <div className="card-rating">
            <FiStar size={12} fill="#C9A84C" color="#C9A84C" />
            <span>{Number(product.avg_rating).toFixed(1)}</span>
            {product.review_count > 0 && <span className="rev-count">({product.review_count})</span>}
          </div>
        )}
        {!outOfStock && product.inventory !== undefined && product.inventory !== null && (
          <p className="card-stock">Available: {Number(product.inventory)}</p>
        )}
      </div>
    </div>
  );
}
